<template>
  <div class="section-box project-pay">
    <el-row class="row-bg">
      <el-col :span="12" style="text-align: left; line-height: 36px">
        <!-- <el-badge :value="icon.a" style="margin-right: 25px;" :max="99"> -->
        <el-button size="mini" @click="chose(1)" style="margin-right: 25px"
          :class="form.Status == 1 ? 'selected' : ''">待处理</el-button>
        <!-- <el-button
          size="mini"
          @click="chose(7)"
          style="margin-right: 25px"
          :class="form.Status == 7 ? 'selected' : ''"
          >当前结算单</el-button
        >
        <el-button
          size="mini"
          @click="chose(4)"
          style="margin-right: 25px"
          :class="form.Status == 4 ? 'selected' : ''"
          >共青审核中</el-button
        >

        <el-button
          size="mini"
          @click="chose(5)"
          style="margin-right: 25px"
          :class="form.Status == 5 ? 'selected' : ''"
          >共青审核通过</el-button
        > -->

        <!-- </el-badge> -->
        <!-- <el-badge :value="icon.b" style="margin-right: 25px;" :max="99"> -->
        <el-button size="mini" @click="chose(2)" style="margin-right: 25px"
          :class="form.Status == 2 ? 'selected' : ''">已付款</el-button>
        <!-- </el-badge> -->
        <!-- <el-badge :value="icon.c" style="margin-right: 25px;" :max="99"> -->
        <!-- <el-button size="mini" @click="chose(3)" :class="form.invoiceStatus ==3 ?'selected':''">已完成</el-button> -->
        <!-- </el-badge> -->
        <!-- <el-badge :value="icon.d" style="margin-right: 25px;" :max="99"> -->
        <el-button size="mini" @click="chose(3)" style="margin-right: 25px"
          :class="form.Status == 3 ? 'selected' : ''">已拒绝</el-button>
        <!-- </el-badge> -->
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-button size="medium" plain icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
        <el-button size="medium" type="primary" plain v-if="form.Status == 1"
          @click="confirmAll()">确认支付</el-button>
        <el-button size="medium" type="danger" plain v-if="form.Status == 1" @click="showRejectAll()">拒绝支付</el-button>
        <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
        <el-button size="medium" type="success" @click="handleReset">重置</el-button>
      </el-col>
    </el-row>

    <!-- 列表 -->
    <el-table ref="tableData" :stripe="true" :data="tableData" style="width: 100%" height="666" border
      @selection-change="handleSelectionChange" v-loading="listLoading">
      <el-table-column type="selection" width="45" v-if="form.Status == 1" :key="1" align="center"></el-table-column>
      <el-table-column label="提现申请时间" :key="22" width="180">
        <template slot-scope="scope">
          <span :title="scope.row.ApplyId">
            <img v-if="scope.row.IsBpoMemberMonthFirst" style="margin-bottom: -2px" src="@/assets/new/vip.png"
              alt="VIP" />{{ scope.row.ApplyTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单号" :key="2">
        <el-table-column show-overflow-tooltip width="120">
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model.trim="form.JobNo" placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.JobNo || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="银行账号" :key="3">
        <el-table-column show-overflow-tooltip width="170">
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model.trim="form.ApplyAccount" placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.ApplyAccount || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="开户行" :key="4" width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.ApplyAccountName || "--" }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="持卡人姓名" :key="5" >
        <el-table-column show-overflow-tooltip width="110" >
          <template slot="header" slot-scope="scope">
            <!-- <el-input
              size="mini"
              v-model.trim="form.ApplyUserName"
              placeholder="输入关键字搜索"
            /> -->
             <el-select size="mini" v-model="form.UserCode" clearable filterable remote  placeholder="输入关键字搜索"
              :remote-method="searchUsersFromMongo" @clear="userList=[]" :loading="searchUserLoading" >
              <el-option v-for="item in userList" :key="item.UserCode" :label="item.UserNameAndCode" :value="item.UserCode">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.ApplyUserName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="手机号" :key="6">
        <el-table-column show-overflow-tooltip width="120">
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model.trim="form.Handset" placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.Handset || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="身份证号" :key="7">
        <el-table-column show-overflow-tooltip width="170">
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model.trim="form.IdentityNo" placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.IdentityNo || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="金额" :key="8" width="120">
        <template slot-scope="scope">
          <span style="font-size: 15px">￥{{ scope.row.ApplyAmount || "--" }}</span>
          <p style="margin: 0;">{{scope.row.ApplyAmountRemark}}</p>
        </template>
      </el-table-column>
      <el-table-column label="上游回款状态" :key="9">
        <el-table-column show-overflow-tooltip width="150">
          <template slot="header" slot-scope="scope">
            <el-select size="mini" v-model.trim="form.ReturnMoneyStatus" placeholder="请选择" style="width: 100%">
              <el-option v-for="(item, index) in statusArr" :key="index" :value="item.JobStatus"
                :label="item.JobStatusTxt">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.ReturnMoneyStatusName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="是否有垫资申请" :key="10">
        <el-table-column show-overflow-tooltip width="120">
          <template slot="header" slot-scope="scope">
            <el-select size="mini" v-model.trim="form.JobAdvanceFunds" placeholder="请选择" style="width: 100%">
              <el-option v-for="(item, index) in yesnoOptions" :key="index" :value="item.value"
                :label="item.label">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.IsJobAdvanceFunds ? '是' : '否' }}</span>
            <!-- 新增是否有垫资申请，若有则可点击查看企微的申请单 -->
            <el-button v-if="scope.row.IsJobAdvanceFunds" type="text" style="position: absolute;right: 0;padding: 4px 10px;" @click="handledView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="是否满足22工作日" :key="11">
        <el-table-column show-overflow-tooltip width="135">
          <template slot="header" slot-scope="scope">
            <el-select size="mini" v-model.trim="form.EnoughTime" placeholder="请选择" style="width: 100%">
              <el-option v-for="(item, index) in yesnoOptions" :key="index" :value="item.value"
                :label="item.label">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.IsEnoughTime ? '是' : '否'}}</span>
          </template>
        </el-table-column>
      </el-table-column>
       <el-table-column label="审核备注" :key="12" v-if="form.Status==3">
        <el-table-column show-overflow-tooltip width="135">
          <!-- <template slot="header" slot-scope="scope">
            <el-select size="mini" v-model.trim="form.EnoughTime" placeholder="请选择" style="width: 100%">
              <el-option v-for="(item, index) in yesnoOptions" :key="index" :value="item.value"
                :label="item.label">
              </el-option>
            </el-select>
          </template> -->
          <template slot-scope="scope">
            <span>{{ scope.row.AuditRemark ?? '--'}}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <p style="margin-bottom: -42px; font-size: 14px; line-height: 32px" v-if="form.Status == 1 || form.Status == 5 || form.Status == 7">
      已选 {{ chooseInfo.num }} 条，共计：￥{{chooseInfo.allPrice | formatPrice }}元
    </p>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.PageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <advanceFundsDetail ref="advanceFundsDetail"/>
  
       <el-dialog title="拒绝支付" :visible.sync="rejectDiaShow" width="30%" :close-on-click-modal="false" ref="dialog"
            append-to-body>
            <el-form label-position="left" label-width="80px">
                <el-form-item label="备注：">
                    <el-input
                    type="textarea"
                    :autosize="{ minRows: 4 }"
                    placeholder="请输入备注"
                    maxlength="350"
                    v-model="auditRemark"   show-word-limit> </el-input>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <p style="display: inline-block;vertical-align: middle;text-align: left;width: 88%;font-size: 14px;color: #f75959;">请谨慎选择，选择后无法调整</p> -->
                <el-button type="primary" size="small" @click="receivedAll">确 定</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
import { getStorageToken } from "@/utils/store";
import {
  GetCommissionApplyList, //获取提现列表
  WithdrawApplyConfirmPay, //确认付款
  WithdrawApplyReject, //拒绝付款
  SyncGqData, //同步数据
  MakePushGqFlag, //推送数据
  SubmitSettleBill, //提交当前结算单
} from "@/service/payApi";

import { searchUsersFromMongo } from '@/service/login'
import advanceFundsDetail from "./index/advanceFundsDetail.vue"
export default {
  components: {
    advanceFundsDetail
  },
  data() {
    return {
      listLoading: false,
      rejectDiaShow:false,
      auditRemark:'',//拒绝备注
      form: {
        PageNum: 1,
        PageSize: 10,

        JobNo: "",
        ApplyTime: [], //申请时间
        ApplyAccountName: "", //支付机构
        ApplyAccount: "", //支付账号
        ApplyUserName: "", //收款户号
        UserCode: "", //用户Code
        Handset: "", //手机号
        IdentityNo: "", //身份证号

        MinApplyMpValue: "", //提现余额 低价
        MaxApplyMpValue: "", //提现余额 高价

        SettlementParty: "", //打款方 0全部， 1速派，2江西速服

        Status: 1, //状态 0全部 1待处理，2已付款，3已拒绝
        JobAdvanceFunds: null,
        EnoughTime: null,
        ReturnMoneyStatus: null
      },

      statusArr2: [
        //状态
        {
          JobStatus: 0,
          JobStatusTxt: "全部",
        },
        {
          JobStatus: 1,
          JobStatusTxt: "未开票",
        },
        {
          JobStatus: 2,
          JobStatusTxt: "已开票未回款",
        },
        {
          JobStatus: 3,
          JobStatusTxt: "已回款",
        },
        {
          JobStatus: 4,
          JobStatusTxt: "已部分回款",
        },
        {
          JobStatus: 5,
          JobStatusTxt: "充值客户",
        },
      ],
      statusArr: [
        //上游回款状态
        {
          JobStatus: 1,
          JobStatusTxt: "未开票",
        },
        {
          JobStatus: 2,
          JobStatusTxt: "已开票未回款",
        },
        {
          JobStatus: 3,
          JobStatusTxt: "已回款",
        },
        {
          JobStatus: 4,
          JobStatusTxt: "已回部分款",
        },
        {
          JobStatus: 5,
          JobStatusTxt: "充值客户",
        },
      ],
      yesnoOptions: [{
        value: 1,
        label: '是'
      }, {
        value: 2,
        label: '否'
      }],
      chooseInfo: {
        num: 0,
        allPrice: 0
      },
      searchData: {},
      oraginForm: {},
      tableData: [],
      total: 0, //总条数

      selected_items: {},

      searchUserLoading: false,//搜索用户的loadding
      userList: [] //收款账户下来搜索框
    };
  },
  activated() {
    this.handleSearch();
  },
  created() {
    this.oraginForm = JSON.parse(JSON.stringify(this.form));
    this.tableData = [];
  },
  computed: {},
  mounted() { 
  },
  methods: {
    downloadFile() {
      const _this = this;
      let data = JSON.parse(JSON.stringify(this.searchData));
      if (data.ApplyTime instanceof Array && data.ApplyTime.length > 0) {
        data.ApplyStartTime = data.ApplyTime[0];
        data.ApplyEndTime = data.ApplyTime[1];
      }
      delete data.ApplyTime;
      // !data.ApplyAccountName && delete data.ApplyAccountName
      // !data.ApplyAccount && delete data.ApplyAccount
      // !data.ApplyUserName && delete data.ApplyUserName
      // !data.UserCode && delete data.UserCode
      // !data.Handset && delete data.Handset
      // !data.IdentityNo && delete data.IdentityNo
      // !data.MinApplyMpValue && delete data.MinApplyMpValue
      // !data.MaxApplyMpValue && delete data.MaxApplyMpValue

      let url =
        process.env.NODE_ENV == "development"
          ? "/api4"
          : process.env.VUE_APP_API4;

          window.open(
            url +
            "/api/WithdrawApply/ExportCommissionApply" +
            "?" +
            this.parseJsonURL(data)
          );
    },
    parseJsonURL(json) {
      if (!json) return "";
      if (typeof json == "string") return json;
      return this.cleanArray(
        Object.keys(json).map(function (key) {
          if (json[key] === undefined) return "";
          return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
      ).join("&");
    },
    cleanArray(actual) {
      var newArray = [];
      for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    },

    chose(type) {
      this.form.Status = type;
      this.handleReset();
    },
    //渲染列表
    handleSearch() {
      this.searchData = Object.assign({}, this.form);
      this.GetCommissionApplyList();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = val;
      this.searchData.PageNum = val;
      this.GetCommissionApplyList();
    },
    //翻页
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = 1;
      this.form.PageSize = val;
      this.searchData.PageNum = 1;
      this.searchData.PageSize = val;
      this.GetCommissionApplyList();
    },
    // TODO：修改接口名 form参数 table展示数据 -> 发单方身份、服务来源select
    async GetCommissionApplyList() {
      let _this = this;
      let data = JSON.parse(JSON.stringify(this.searchData));
      if (data.ApplyTime instanceof Array && data.ApplyTime.length > 0) {
        data.ApplyStartTime = data.ApplyTime[0];
        data.ApplyEndTime = data.ApplyTime[1];
      }
      delete data.ApplyTime;
      if (data.SettlementParty == "") {
        data.SettlementParty = 0;
      }
      !data.JobNo && delete data.JobNo;
      !data.ApplyAccountName && delete data.ApplyAccountName;
      !data.ApplyAccount && delete data.ApplyAccount;
      !data.ApplyUserName && delete data.ApplyUserName;
      !data.UserCode && delete data.UserCode;
      !data.Handset && delete data.Handset;
      !data.IdentityNo && delete data.IdentityNo;
      !data.MinApplyMpValue && delete data.MinApplyMpValue;
      !data.MaxApplyMpValue && delete data.MaxApplyMpValue;
      !data.JobAdvanceFunds && delete data.JobAdvanceFunds;
      !data.EnoughTime && delete data.EnoughTime;
      !data.ReturnMoneyStatus && delete data.ReturnMoneyStatus;
      !data.SettlementParty && delete data.SettlementParty;
      this.listLoading = true;
      let res = await GetCommissionApplyList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      //   const old = JSON.parse(JSON.stringify(this.selected_items));
      //   this.selected_items = {};

      this.tableData = res.Data.ApplyList;
      this.total = res.Data.TotalCount;

      this.$forceUpdate();
      this.selected_items = {};
    },
    
    //从mongo获取用户
    searchUsersFromMongo(seachKey) {
    console.log('seachKey:'+seachKey);
     seachKey=this.removeSpaces(seachKey);

      if (seachKey != "") {
        this.searchUserLoading = true;
        var that = this;
        console.log('---searchUsersFromMongo--');
        setTimeout(() => {
          var data = {
            PageNum: 1,
            PageSize: 100,
            UserType: 0,
            SearchKey: seachKey
          };
          console.log('data:' + JSON.stringify(data));
          let res = searchUsersFromMongo(data).then(res => {
            that.searchUserLoading=false;
            if (res.Result != 1) {
              return this.$message.error(res.Message);
            }
            that.userList = res.Data;
            console.log("userList:" + JSON.stringify(that.userList));

          });

        }, 200);
      }
      else {
        this.userList = [];
      }
    },
    removeSpaces(str) {
      return str.replace(/\s+/g, '');
    },
    handleReset() {
      this.oraginForm.Status = this.form.Status; //重置时，状态不重置
      this.form = JSON.parse(JSON.stringify(this.oraginForm));
      this.handleSearch();

      this.selected_items = {};
      this.$forceUpdate();
    },
    // table选中
    handleSelectionChange(val) {
      this.selected_items = val;
      let allPrice = 0;
      this.selected_items.filter(item=> allPrice += item.ApplyAmount)
        // for (var idx in this.tableData) {
        //   console.info(idx);
        //   const item = this.tableData[idx];
        //   if (this.selected_items[item.Id]) delete this.selected_items[item.id];
        // }
      //   for (var idxs in val) {
      //     const item2 = val[idxs];
      //     this.selected_items[item2.Id] = item2;
      //   }
        
      // debugger
      // console.table(val)
      this.chooseInfo = {
        num: Object.keys(this.selected_items).length,
        allPrice
      }
      console.log("00", this.chooseInfo);
    },
    //推送到共青,已不用
    makePushGqFlag(isMake) {
      const _this = this;

      if (
        this.selected_items == undefined ||
        Object.keys(this.selected_items).length <= 0
      ) {
        return this.$message.warning("请选择选项");
      }

      var ids = [];
      for (var key in this.selected_items) {
        const item = this.selected_items[key];
        if (item.SettlementParty != 3) {
          return this.$message.warning("所选非代征提现");
        }

        ids.push(item.Id);
      }


      var msg = isMake ? "确认推送数据到共青？" : "确认取消推送数据到共青？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        //distinguishCancelAndClose: true,
        type: "warning",
      })
        .then(() => {
          _this.listLoading = true;
          MakePushGqFlag({ IdList: ids, IsMake: isMake }).then((r) => {
            _this.listLoading = false;
            if (r.Result != 1) {
              return _this.$message.error(r.Message);
            }
            _this.$message.success(r.Message);
            _this.handleReset();
          });
        })
        .catch((action) => { });
    },
    //提交当前结算单(共青),已不用
    submitSettleBill() {
      //提交当前结算单
      const _this = this;
      var ids = [];

      for (var key in this.selected_items) {
        const item = this.selected_items[key];
        ids.push(item.Id);
      }
      if (ids.length <= 0) {
        return this.$message.warning("请选择选项");
      }

      this.$confirm("确认提交结算单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        //distinguishCancelAndClose: true,
        type: "warning",
      })
        .then(() => {
          _this.listLoading = true;
          SubmitSettleBill({ WithdrawApplyIdList: ids }).then((r) => {
            _this.listLoading = false;
            if (r.Result != 1) {
              return _this.$alert(r.Message);
            }
            _this.$message.success(r.Message);
            _this.handleReset();
          });
        })
        .catch((action) => { });
    },
    // 点击确认
    confirmAll() {
      const _this = this;
      var ids = [];
      var temp = "";
      let tips = "是否确认支付？";
      let hasAF = false, hasNoET = false, hasNoReturnMoney = false;
      for (var key in this.selected_items) {
        const item = this.selected_items[key];
        ids.push(item.ApplyId);
        temp += item.ApplyId + ",";
        if (item.IsJobAdvanceFunds ) {
          hasAF = true;
        }
        if (!item.IsEnoughTime) {
          hasNoET = true;
        }
        if (item.ReturnMoneyStatus != 5 || item.ReturnMoneyStatus != 3 || !item.JobId) {
          hasNoReturnMoney = true;
        }
      }
      if (hasAF && hasNoET) {
        tips = "确认付款订单中存在垫资订单且存在未到期订单，是否确认操作";
      }else if (hasAF) {
        tips = "确认付款订单中存在垫资订单，是否确认操作";
      }else if (hasNoET) {
        tips = "确认付款订单中存在未到期订单，是否确认操作";
      }else if (hasNoReturnMoney) {
        tips = "确认付款订单中存在未回款/部分回款订单，是否确认操作";
      }

      temp = temp.substr(0, temp.length - 1);
      if (!temp) {
        return this.$message.warning("请选择选项");
      }
      
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "重新选择",
        type: "warning",
      })
        .then(() => {
          var data = {
            IdArray: ids,
          };
          _this.listLoading = true;
          WithdrawApplyConfirmPay(data).then((r) => {
            _this.listLoading = false;
            if (r.Result != 1) {
              return _this.$message.error(r.Message);
            }
            _this.$message.success("操作成功！");
            _this.handleReset();
          });
        })
        .catch(() => { });
    },

    //展示拒绝弹窗
    showRejectAll(){
      this.rejectDiaShow=true;
      this.auditRemark='';
    },
    //点击拒绝
    receivedAll() {
      const _this = this;
      var ids = [];
      var temp = "";
      for (var key in this.selected_items) {
        const item = this.selected_items[key];
        ids.push(item.ApplyId);
        temp += item.ApplyId + ",";
      }

      temp = temp.substr(0, temp.length - 1);
      if (!temp) {
        return this.$message.warning("请选择选项");
      }
      let tips = "是否拒绝支付？";

      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            IdArray: ids,
            AuditRemark:this.auditRemark
          };
          _this.listLoading = true;
          WithdrawApplyReject(data).then((r) => {
            _this.listLoading = false;
            _this.rejectDiaShow=false;
            if (r.Result != 1) {
              return _this.$message.error(r.Message);
            }
            _this.$message.success("操作成功！");
            _this.handleReset();
          });
        })
        .catch(() => { });
    },
    //同步数据，共青，已不用
    syncGqData() {
      const _this = this;
      _this.listLoading = true;

      SyncGqData({}).then((r) => {
        _this.listLoading = false;

        if (r.Result != 1) {
          return _this.$message.warning(r.Message);
        }
        _this.$message.success(r.Message);
        _this.handleReset();
      });
    },
    handledView(item) {
      this.$refs.advanceFundsDetail.open(item.JobId)
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.row-bg {
  padding: 10px 14px;
  background-color: #f9fafc;
}

.project-pay {
  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
::v-deep thead .el-checkbox__inner {
  display: none !important;
}
</style>